export default __webpack_public_path__ + "static/media/k2banner.2d61adf4.jpg";